import React, { forwardRef, useEffect, useState } from 'react';
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row } from '../../components/Component';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthTenantLoader from '../loaders/AuthTenantLoader';
import AuthTenantPageError from '../error/AuthTenantPageError';
import AuthTenantNoData from '../error/AuthTenantNoData';
import { fail_retrieve_specific_tenant_product_details, loading_retrieve_specific_tenant_product_details, reset_retrieve_specific_tenant_product_details, success_retrieve_specific_tenant_product_details } from '../../reducers/auth_tenant/retrieve_specific_tenant_product_details_Slice';
import { messageToast } from '../../utils/Utils';
import { RETRIEVE_SPECIFIC_SALES_REP_ALLOWED_PRODUCTS_LIST_API } from '../../api/api_data';
import { RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { useSelector } from 'react-redux';
import * as app_consts from "../../utils/app_consts";
import { Badge, Card } from 'reactstrap';
import moment from 'moment/moment';
import AddToOrderModal from '../../components/modal/AddToOrderModal';

const initialOrderState = {
  warehouse_site_id: "",
  color: "",
  packet_size: "",
  return_date: moment(new Date()).format("YYYY-MM-DD"),
  units: 1
};

const ProductsListingDetails = ({ tenant_info, user_info }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState(null);
  const { product_id } = useParams();
  const [available_inventory, setAvailableInventory] = useState([]);
  const [unique_locations, setUniqueLocations] = useState([]);
  const [current_available_colors, setCurrentAvailableColors] = useState([]);
  const [current_available_packetSizes, setCurrentAvailablePacketSizes] = useState([]);
  const [add_orders_form_data, setAddOrderFormData] = useState(initialOrderState);
  const [add_to_cart_modal, setAddToCartModal] = useState(false);
  const [order_data, setOrderData] = useState(null);

  // Retrieve Product
  useEffect(() => {
    retrieve_product_details();
    setAddOrderFormData(prev => ({ ...prev, product_id }));
  }, [product_id]);

  const retrieve_product_details = () => {
    dispatch(
      tenant_auth_actions_helper(
        loading_retrieve_specific_tenant_product_details,
        success_retrieve_specific_tenant_product_details,
        fail_retrieve_specific_tenant_product_details,
        RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG,
        RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG,
        app_consts.GET,
        `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_SALES_REP_ALLOWED_PRODUCTS_LIST_API}/${product_id}`
      )
    );
  };

  const retrieve_specific_tenant_product_details_listener = useSelector(
    (state) => state.retrieve_specific_tenant_product_details.retrieve_specific_tenant_product_details
  );

  useEffect(() => {
    if (retrieve_specific_tenant_product_details_listener.status !== app_consts.IDLE)
    {
      setLoading(retrieve_specific_tenant_product_details_listener.status === app_consts.LOADING);

      if (retrieve_specific_tenant_product_details_listener.status === app_consts.FAIL)
      {
        setError(retrieve_specific_tenant_product_details_listener.message);
        messageToast(retrieve_specific_tenant_product_details_listener.message, app_consts.FAIL);
      }
      else if (retrieve_specific_tenant_product_details_listener.status === app_consts.SUCCESS)
      {
        setPageData(retrieve_specific_tenant_product_details_listener.data);
        setAvailableInventory(retrieve_specific_tenant_product_details_listener.data?.available_inventory || []);
      }

      dispatch(reset_retrieve_specific_tenant_product_details());
    }
  }, [retrieve_specific_tenant_product_details_listener]);

  useEffect(() => {
    if (available_inventory.length > 0)
    {
      const locationsMap = {};
      const colorsMap = {};
      const sizesMap = {};

      available_inventory.forEach((invent) => {
        const warehouseId = invent?.warehouse_site?.id;
        const color = invent?.color;
        const size = invent?.packet_size;
        const units = invent?.units || 0;

        // Process locations
        if (warehouseId)
        {
          if (!locationsMap[warehouseId])
          {
            locationsMap[warehouseId] = {
              warehouse_site: invent?.warehouse_site?.name,
              id: warehouseId,
              type: invent?.warehouse_site?.type,
              units: 0,
            };
          }
          locationsMap[warehouseId].units += units;
        }

        // Process colors
        if (color)
        {
          if (!colorsMap[color])
          {
            colorsMap[color] = { color, units: 0 };
          }
          colorsMap[color].units += units;
        }

        // Process sizes
        if (size)
        {
          if (!sizesMap[size])
          {
            sizesMap[size] = { packet_size: size, units: 0 };
          }
          sizesMap[size].units += units;
        }
      });

      setUniqueLocations(Object.values(locationsMap));
      setCurrentAvailableColors(Object.values(colorsMap));
      setCurrentAvailablePacketSizes(Object.values(sizesMap));
    }
  }, [available_inventory]);

  const handle_location_check = (selected_location_id) => {
    if (add_orders_form_data?.warehouse_site_id === selected_location_id)
    {
      setAddOrderFormData(initialOrderState);
    } else
    {
      const filteredInventory = available_inventory.filter(
        (invent) => invent?.warehouse_site?.id === selected_location_id
      );

      const colorsMap = {};
      const sizesMap = {};

      filteredInventory.forEach((invent) => {
        const color = invent?.color;
        const size = invent?.packet_size;
        const units = invent?.units || 0;

        if (color)
        {
          if (!colorsMap[color])
          {
            colorsMap[color] = { color, units: 0 };
          }
          colorsMap[color].units += units;
        }

        if (size)
        {
          if (!sizesMap[size])
          {
            sizesMap[size] = { packet_size: size, units: 0 };
          }
          sizesMap[size].units += units;
        }
      });

      setCurrentAvailableColors(Object.values(colorsMap));
      setCurrentAvailablePacketSizes(Object.values(sizesMap));

      setAddOrderFormData({
        ...initialOrderState,
        warehouse_site_id: selected_location_id,
        product_id
      });
    }
  };

  const handle_color_select = (selected_color) => {
    if (add_orders_form_data?.color === selected_color)
    {
      setAddOrderFormData(prev => ({ ...prev, color: "", packet_size: "" }));
    } else
    {
      const filteredInventory = available_inventory.filter(
        (invent) =>
          invent?.warehouse_site?.id === add_orders_form_data?.warehouse_site_id &&
          invent?.color === selected_color
      );

      const sizesMap = {};
      filteredInventory.forEach((invent) => {
        const size = invent?.packet_size;
        const units = invent?.units || 0;

        if (size)
        {
          if (!sizesMap[size])
          {
            sizesMap[size] = { packet_size: size, units: 0 };
          }
          sizesMap[size].units += units;
        }
      });

      setCurrentAvailablePacketSizes(Object.values(sizesMap));

      setAddOrderFormData(prev => ({
        ...prev,
        color: selected_color,
        packet_size: ""
      }));
    }
  };

  const handle_packet_size_select = (packet_size) => {
    setAddOrderFormData(prev => ({
      ...prev,
      packet_size: prev.packet_size === packet_size ? "" : packet_size
    }));
  };

  const handle_quantity_change = (newUnits) => {
    newUnits = Math.max(1, newUnits);
    setAddOrderFormData(prev => ({ ...prev, units: newUnits }));
  };

  const handle_date_change = (e) => {
    setAddOrderFormData(prev => ({
      ...prev,
      return_date: e.target.value
    }));
  };

  const openAddToCartModal = () => {
    setOrderData({
      total_value: calculateTotalValue(),
      units: add_orders_form_data?.units,
      warehouse_site_id: add_orders_form_data?.warehouse_site_id,
      product_id,
      color: add_orders_form_data?.color,
      packet_size: add_orders_form_data?.packet_size,
      return_date: add_orders_form_data?.return_date,
      returnable: page_data?.returnable
    });
    setAddToCartModal(true);
  };

  const closeAddCartModal = () => {
    setAddToCartModal(false);
  };

  const calculateTotalValue = () => {
    if (!page_data?.product_value || !add_orders_form_data?.units) return 0;
    return (parseFloat(page_data.product_value) * parseInt(add_orders_form_data.units)).toFixed(2);
  };

  const isFormFilled =
    add_orders_form_data?.warehouse_site_id &&
    add_orders_form_data?.packet_size &&
    add_orders_form_data?.color &&
    add_orders_form_data?.units &&
    (page_data?.returnable ? add_orders_form_data?.return_date : true);

  const successAddOrderItem = () => {
    closeAddCartModal();
    retrieve_product_details();
    setAddOrderFormData(initialOrderState);
  };

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Product Details` : "Product Details"} />
      <Content>
        <BlockHead size="lg">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Product Details</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Link to={`/${tenant_info?.url_prefix}/products`} className="text-decoration-none">
                <Button color="light" outline className="bg-white">
                  <Icon name="arrow-left"></Icon>
                  <span>Back to Products</span>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {loading ? (
          <AuthTenantLoader tenant_info={tenant_info} />
        ) : error ? (
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
        ) : page_data ? (
          <Block>
            <Card className="card-bordered">
              <Row className="g-4">
                {/* Product Image Column */}
                <Col lg={5}>
                  <div className="product-image-container">
                    <img
                      src={page_data?.product_img || '/images/default-product.png'}
                      alt={page_data?.name}
                      className="product-image"
                      onError={(e) => {
                        e.target.src = '/images/default-product.png';
                      }}
                    />
                  </div>
                </Col>

                {/* Product Details Column */}
                <Col lg={7}>
                  <div className="product-details">
                    <div className="d-flex justify-content-between align-items-start mb-4">
                      <div>
                        <h2 className="product-title">{page_data?.name}</h2>
                        <div className="product-category mb-3">
                          <Badge color="light" className="text-primary">
                            {page_data?.category || "Uncategorized"}
                          </Badge>
                        </div>
                        <div className="product-price mb-3">
                          <span className="h4 text-success">
                            {page_data?.product_value ? `${parseFloat(page_data.product_value).toFixed(2)} ZMW` : "--"}
                          </span>
                        </div>
                      </div>
                      <div className="product-status">
                        <Badge color={page_data?.status === 'active' ? "success" : "danger"}>
                          {page_data?.status?.toUpperCase() || "--"}
                        </Badge>
                      </div>
                    </div>

                    {/* Product Info */}
                    <div className="product-info-grid mb-4">
                      <div className="info-item">
                        <span className="info-label">Product Type:</span>
                        <span className="info-value">{page_data?.product_type || "--"}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">SKU:</span>
                        <span className="info-value">{page_data?.sku_no || "--"}</span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Returnable:</span>
                        <span className="info-value">
                          {page_data?.returnable ? (
                            <Badge color="success">Yes</Badge>
                          ) : (
                            <Badge color="secondary">No</Badge>
                          )}
                        </span>
                      </div>
                    </div>

                    {/* Order Form */}
                    <Card className="card-bordered mt-4">
                      <div className="card-inner p-4">
                        <h5 className="card-title mb-4">Order Details</h5>

                        {/* Location Selection */}
                        <div className="form-section mb-4">
                          <h6 className="section-title mb-3">Location</h6>
                          <div className="location-options">
                            {unique_locations?.map((locate, index) => (
                              <div key={index} className="location-option">
                                <input
                                  type="radio"
                                  id={`location-${index}`}
                                  name="location"
                                  onChange={() => handle_location_check(locate?.id)}
                                  checked={add_orders_form_data?.warehouse_site_id === locate?.id}
                                />
                                <label htmlFor={`location-${index}`}>
                                  <span className="location-name">{locate?.warehouse_site}</span>
                                  <span className="location-stock">({locate?.units} units available)</span>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Color Selection */}
                        {page_data?.colors?.length > 0 && (
                          <div className="form-section mb-4">
                            <h6 className="section-title mb-3">Color</h6>
                            <div className="color-options">
                              {page_data.colors.map((color, index) => {
                                const matchingColor = current_available_colors?.find((item) => item.color === color);
                                const isDisabled = !matchingColor || matchingColor.units <= 0;
                                return (
                                  <div key={index} className={`color-option ${isDisabled ? 'disabled' : ''}`}>
                                    <input
                                      type="radio"
                                      id={`color-${index}`}
                                      name="color"
                                      disabled={isDisabled || !add_orders_form_data?.warehouse_site_id}
                                      onChange={() => handle_color_select(color)}
                                      checked={add_orders_form_data?.color === color}
                                    />
                                    <label htmlFor={`color-${index}`}>
                                      <span className="color-name">{color}</span>
                                      <span className="color-stock">
                                        {isDisabled ? "(Unavailable)" : `(${matchingColor.units} available)`}
                                      </span>
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {/* Size Selection */}
                        {page_data?.packet_sizes?.length > 0 && (
                          <div className="form-section mb-4">
                            <h6 className="section-title mb-3">Size</h6>
                            <div className="size-options">
                              {page_data.packet_sizes.map((size, index) => {
                                const matchingSize = current_available_packetSizes?.find((item) => item.packet_size === size);
                                const isDisabled = !matchingSize || matchingSize.units <= 0;
                                return (
                                  <div key={index} className={`size-option ${isDisabled ? 'disabled' : ''}`}>
                                    <input
                                      type="radio"
                                      id={`size-${index}`}
                                      name="size"
                                      disabled={isDisabled || !add_orders_form_data?.color}
                                      onChange={() => handle_packet_size_select(size)}
                                      checked={add_orders_form_data?.packet_size === size}
                                    />
                                    <label htmlFor={`size-${index}`}>
                                      <span className="size-name">{size}</span>
                                      <span className="size-stock">
                                        {isDisabled ? "(Unavailable)" : `(${matchingSize.units} available)`}
                                      </span>
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {/* Quantity Selector */}
                        <div className="form-section mb-4">
                          <h6 className="section-title mb-3">Quantity</h6>
                          <div className="quantity-selector">
                            <Button
                              color="light"
                              outline
                              className="quantity-btn"
                              onClick={() => handle_quantity_change(add_orders_form_data?.units - 1)}
                              disabled={!add_orders_form_data?.packet_size || add_orders_form_data?.units <= 1}
                            >
                              <Icon name="minus"></Icon>
                            </Button>
                            <input
                              type="number"
                              className="quantity-input"
                              value={add_orders_form_data?.units}
                              onChange={(e) => handle_quantity_change(parseInt(e.target.value, 10))}
                              min="1"
                              disabled={!add_orders_form_data?.packet_size}
                            />
                            <Button
                              color="light"
                              outline
                              className="quantity-btn"
                              onClick={() => handle_quantity_change(add_orders_form_data?.units + 1)}
                              disabled={!add_orders_form_data?.packet_size}
                            >
                              <Icon name="plus"></Icon>
                            </Button>
                          </div>
                        </div>

                        {/* Return Date (if returnable) */}
                        {page_data?.returnable && (
                          <div className="form-section mb-4">
                            <h6 className="section-title mb-3">Return Date</h6>
                            <input
                              type="date"
                              name="return_date"
                              value={add_orders_form_data?.return_date}
                              className="form-control"
                              min={new Date().toISOString().split("T")[0]}
                              onChange={handle_date_change}
                            />
                          </div>
                        )}

                        {/* Total Value */}
                        <div className="total-value-section mb-4 p-3 bg-light rounded">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="total-label">Total Value:</span>
                            <span className="total-amount h5 text-success">
                              {calculateTotalValue()} ZMW
                            </span>
                          </div>
                        </div>

                        {/* Add to Order Button */}
                        <Button
                          color="primary"
                          size="lg"
                          block
                          disabled={!isFormFilled}
                          onClick={openAddToCartModal}
                          className="mt-3"
                        >
                          <Icon name="cart" className="me-2"></Icon>
                          Add to Order
                        </Button>
                      </div>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Card>

            {/* Add to Cart Modal */}
            <AddToOrderModal
              isOpen={add_to_cart_modal}
              closeModal={closeAddCartModal}
              data={order_data}
              tenant_info={tenant_info}
              user_info={user_info}
              product_name={page_data?.name}
              successFunction={successAddOrderItem}
            />
          </Block>
        ) : (
          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Product Information Found"} />
        )}
      </Content>

      <style jsx>{`
        .product-image-container {
          height: 400px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          background-color: #f8f9fa;
          border-radius: 8px;
        }

        .product-image {
          max-height: 100%;
          max-width: 100%;
          object-fit: contain;
        }

        .product-title {
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 0.5rem;
        }

        .product-info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 1rem;
        }

        .info-item {
          display: flex;
          flex-direction: column;
        }

        .info-label {
          font-size: 0.85rem;
          color: #6c757d;
          margin-bottom: 0.25rem;
        }

        .info-value {
          font-weight: 500;
          color: #212529;
        }

        .form-section {
          margin-bottom: 1.5rem;
        }

        .section-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #495057;
        }

        .location-options,
        .color-options,
        .size-options {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .location-option,
        .color-option,
        .size-option {
          position: relative;
        }

        .location-option input,
        .color-option input,
        .size-option input {
          position: absolute;
          opacity: 0;
        }

        .location-option label,
        .color-option label,
        .size-option label {
          display: flex;
          flex-direction: column;
          padding: 0.75rem 1rem;
          border: 1px solid #e5e9f2;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
          background-color: #fff;
        }

        .location-option input:checked + label,
        .color-option input:checked + label,
        .size-option input:checked + label {
          border-color: #6576ff;
          background-color: rgba(101, 118, 255, 0.05);
        }

        .location-option input:disabled + label,
        .color-option input:disabled + label,
        .size-option input:disabled + label {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .location-name,
        .color-name,
        .size-name {
          font-weight: 500;
          margin-bottom: 0.25rem;
          color: #212529;
        }

        .location-stock,
        .color-stock,
        .size-stock {
          font-size: 0.75rem;
          color: #6c757d;
        }

        .quantity-selector {
          display: flex;
          align-items: center;
          max-width: 150px;
        }

        .quantity-btn {
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px !important;
        }

        .quantity-input {
          width: 50px;
          text-align: center;
          margin: 0 0.5rem;
          height: 36px;
          border: 1px solid #e5e9f2;
          border-radius: 6px;
        }

        .total-value-section {
          border: 1px solid #e5e9f2;
        }

        .total-label {
          font-weight: 500;
          color: #495057;
        }

        .total-amount {
          font-weight: 600;
        }
      `}</style>
    </>
  );
};

export default ProductsListingDetails;